import { Button, Modal, Text } from '@shared/widgets';

interface ILockUserModalProps {
  show: boolean;
  onClose: () => void;
  onSave: () => void;
  locked: boolean;
}

export const LockUserModal = (props: ILockUserModalProps) => {
  return (
    <Modal isOpen={props.show} onClose={props.onClose} title={props.locked ? 'Unlock user' : 'Lock user'}>
      <Text>Are you sure you want to {props.locked ? 'unlock' : 'lock'} the user?</Text>
      <div className='mt-6'>
        <div className='flex justify-between gap-x-1.5'>
          <Button color='outlined' fullWidth onClick={props.onClose}>
            Decline
          </Button>
          <Button
            color='primary'
            fullWidth
            onClick={() => {
              props.onSave();
              props.onClose();
            }}
          >
            {props.locked ? 'Unlock' : 'Lock'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
